// extracted by mini-css-extract-plugin
export var divider = "_rh-0";
export var systemMessage = "_rh-1";